/* unplugin-vue-components disabled */import { render } from "./ai-agents.vue?vue&type=template&id=5314457e&scoped=true"
import script from "./ai-agents.vue?vue&type=script&lang=js"
export * from "./ai-agents.vue?vue&type=script&lang=js"

import "./ai-agents.vue?vue&type=style&index=0&id=5314457e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5314457e"],['__file',"src/components/ai-chat/ai-agents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5314457e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5314457e', __exports__)) {
    api.reload('5314457e', __exports__)
  }
  
  module.hot.accept("./ai-agents.vue?vue&type=template&id=5314457e&scoped=true", () => {
    api.rerender('5314457e', render)
  })

}


export default __exports__